// Gatsby requirements
import React, { useState } from "react"
import { Link } from 'gatsby'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'
import Image from 'utils/image'
import json from './sectionListOfArticles.json'
import jsonEn from './sectionListOfArticlesEn.json'

// Styles
import * as CSS from './sectionListOfArticles.module.scss'

const SectionCards = ({ blok, en }) => {

    // Logic for opening more articles
    const [openMore, setOpenMore] = useState(false)

    // Language
    const articlesJson = en ? jsonEn : json;

    // All post filters
    const filteredArray1 = articlesJson?.filter( obj => obj?.tag_list?.includes(blok?.displayArticlesFromTag) ).map( obj => obj );
    const filteredArray2 = articlesJson?.filter( obj => obj?.tag_list?.includes(blok?.displayArticlesFromTag2) ).map( obj => obj );
    const filteredArray3 = articlesJson?.filter( obj => obj?.tag_list?.includes(blok?.displayArticlesFromTag3) ).map( obj => obj );
    const filteredArray4 = articlesJson?.filter( obj => obj?.tag_list?.includes(blok?.displayArticlesFromTag4) ).map( obj => obj );

    // Combine all post filters
    const filteredArrays = filteredArray1.concat(filteredArray2,filteredArray3,filteredArray4);

    // Sort posts by date
    const sortedArrays = filteredArrays.sort((a, b) => new Date(b?.publishedAtRaw) - new Date(a?.publishedAtRaw))

    // Include only unique posts
    const uniqueArrays = [...new Set(sortedArrays)];
    
    
    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                {blok.richtext &&
                    <RichTextRenderer className={CSS.richtext} data={blok.richtext} />
                }

                {blok.displayArticlesFromTag &&
                    <>
                    <div className={`${CSS.articles} ${openMore === true ? CSS.showMore : ''}`}>
                        {uniqueArrays.map((article, index) => {

                            const URL = article.full_slug;
                            
                            return (
                                (openMore || !blok.amountBeforeReadMore || index < blok.amountBeforeReadMore) && 
                                    <article>
                                        <div className={CSS.thumbnail}>
                                            <Image
                                                img={article?.thumbnail}
                                                sizes="(min-width: 720px) 800px, 100vw"
                                                loading="lazy"
                                            />
                                        </div>
                                        {article?.tag_list?.length > 0 && !blok.hideTag && <a href={(en ? '/en/' : '/') + article?.tag_list[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') + '/'} className={CSS.tag}>{article?.tag_list[0]}</a>}
                                        {article.published_at && !blok.hideDate && <span className={CSS.publishedAt}>{article.published_at}</span>}
                                        <Link to={`/${URL}/`}><h3>{article.name}</h3></Link>
                                        <p>{article.field_meta_description_string}</p>
                                        <p className={CSS.readMore}>
                                            {en ? "Read more" : "Lees verder "}
                                            <img width="10" height="10" src="/icons/arrow-forward.svg" alt="" aria-hidden="true" />
                                        </p>
                                    </article>
                            )
                        })}
                    </div>
                    {uniqueArrays.length > blok?.amountBeforeReadMore && blok?.amountBeforeReadMore &&
                        <button
                            className="button"
                            onClick={() =>
                                openMore === true
                                ? setOpenMore(false)
                                : setOpenMore(true)
                            }
                        >
                            {openMore === true ? 'Minder tonen' : 'Meer tonen'}
                        </button>
                    }
                    </>
                }

                {blok?.articles?.length > 0 &&
                    <>
                    <div className={`${CSS.articles} ${openMore === true ? CSS.showMore : ''}`}>
                        {articlesJson.map((article, index) => {

                            const URL = article.full_slug;
                            const listOfArticles = blok.articles;
                            
                            return (
                                listOfArticles.includes(article.uuid) === true && (openMore || !blok.amountBeforeReadMore || index <= blok.amountBeforeReadMore) &&
                                    <article key={index}>
                                        <div className={CSS.thumbnail}>
                                            <Image
                                                img={article?.thumbnail}
                                                sizes="(min-width: 720px) 800px, 100vw"
                                                loading="lazy"
                                            />
                                        </div>
                                        {article?.tag_list?.length > 0 && !blok.hideTag && <a href={(en ? '/en/' : '/') + article?.tag_list[0]?.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') + '/'} className={CSS.tag}>{article?.tag_list[0]}</a>}
                                        {article.published_at && !blok.hideDate && <span className={CSS.publishedAt}>{article.published_at}</span>}
                                        <Link to={`/${URL}/`}><h3>{article.name}</h3></Link>
                                        <p>{article.field_meta_description_string}</p>
                                        <p className={CSS.readMore}>
                                            {en === true ? 'Read more' : 'Lees verder '}
                                            <img width="10" height="10" src="/icons/arrow-forward.svg" alt="" aria-hidden="true" />
                                        </p>
                                    </article>
                            )
                        })}
                    </div>

                    {blok.articles.length > blok?.amountBeforeReadMore && blok?.amountBeforeReadMore &&
                        <button
                            className="button"
                            onClick={() =>
                                openMore === true
                                ? setOpenMore(false)
                                : setOpenMore(true)
                            }
                        >
                            {en === false && <>{openMore === true ? 'Minder tonen' : 'Meer tonen'}</>}
                            {en === true && <>{openMore === true ? 'Show less' : 'Show more'}</>}
                        </button>
                    }
                    </>
                }


                {blok?.showAllArticles &&
                    <>
                    <div className={`${CSS.articles} ${openMore === true ? CSS.showMore : ''}`}>
                        {articlesJson.map((article, index) => {

                            const URL = article.full_slug;
                            
                            return (
                                (openMore || !blok.amountBeforeReadMore || index <= blok.amountBeforeReadMore) &&
                                    <article key={index}>
                                        <div className={CSS.thumbnail}>
                                            <Image
                                                img={article?.thumbnail}
                                                sizes="(min-width: 720px) 800px, 100vw"
                                                loading="lazy"
                                            />
                                        </div>
                                        {article?.tag_list?.length > 0 && !blok.hideTag && <a href={(en ? '/en/' : '/') + article?.tag_list[0]?.toLowerCase()?.replace(/ /g,'-')?.replace(/[^\w-]+/g,'') + '/'} className={CSS.tag}>{article?.tag_list[0]}</a>}
                                        {article.published_at && !blok.hideDate && <span className={CSS.publishedAt}>{article.published_at}</span>}
                                        <Link to={`/${URL}/`}><h3>{article.name}</h3></Link>
                                        <p>{article.field_meta_description_string}</p>
                                        <p className={CSS.readMore}>
                                            {en === true ? 'Read more' : 'Lees verder '}
                                            <img style={{marginLeft: '0.4em'}} width="10" height="10" src="/icons/arrow-forward.svg" alt="" aria-hidden="true" />
                                        </p>
                                    </article>
                            )
                        })}
                    </div>

                    {articlesJson.length > blok?.amountBeforeReadMore && blok?.amountBeforeReadMore &&
                        <button
                            className="button"
                            onClick={() =>
                                openMore === true
                                ? setOpenMore(false)
                                : setOpenMore(true)
                            }
                        >
                            {en === false && <>{openMore === true ? 'Minder tonen' : 'Meer tonen'}</>}
                            {en === true && <>{openMore === true ? 'Show less' : 'Show more'}</>}
                        </button>
                    }
                    </>
                }

            </div>

        </section>
    )
}

export default SectionCards